/**
 * Applicant type code values. Only the ones that are needed for reference are
 * included in this file.
 */
export const ApplicantTypeCodes = {
    individual: 'I',
};
